<template>
  <div>
    <Topbar title="Univers" backButton />
    <section class="Section">
      <div class="Section__header">
        <h2 class="Section__title">TOUS LES UNIVERS CAPTAIN VIN</h2>
      </div>
      <div class="Section__content">
        <ul class="UniverseList">
          <li v-for="universe in universes" :key="universe.id">
            <router-link :to="{name: 'Universe', params: { id: universe.id }}">
              <UniverseCard v-bind="universe" />
            </router-link>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
import universeService from "../services/universe";
import UniverseCard from "../components/UniverseCard";

export default {
  data() {
    return {
      universes: []
    };
  },
  created() {
    universeService.getAll()
      .then(({ data: universes }) => this.universes = universes);
  },
  components: { UniverseCard }
};
</script>
